'use client'

import React from 'react';
import { useConsent } from '../../../providers/ConsentProvider';

type ConsentBannerProps = {

}

export default function ConsentBanner({

}: ConsentBannerProps) {

    const { showBanner, acceptConsent, declineConsent } = useConsent();

    if (!showBanner) return null;

    return (
        <>
            {/* Bloc fixe en bas à gauche : rendu dès le HTML initial, sans décalage de mise en page */}
            <div
                className="toast cookies show text-white border-0"
                role="region"
                aria-label="Cookies"
                style={{ position: 'fixed', left: 16, bottom: 16, zIndex: 9999, width: 'calc(100% - 32px)', maxWidth: 400, padding: 16 }}
            >
                <div className="toast-body p-0 mb-3">Nous utilisons des cookies pour analyser le trafic et améliorer votre expérience.</div>
                <div className="d-flex align-items-center justify-content-end gap-2">
                    <button className="btn btn-link btn-sm text-white" style={{ marginBottom: 0 }} onClick={declineConsent}>Refuser</button>
                    <button className="btn button-primary btn-sm" style={{ marginBottom: 0 }} onClick={acceptConsent}>Accepter</button>
                </div>
            </div>
        </>
    )
}
